import type { I18nTranslation } from '@crehana/i18n';

import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

export const CoursesLocalesBundle: I18nTranslation = { es, pt, en };
